import logo from '@img/logo.png'
import accueil from '@img/sygem.svg'

/* @ngInject */
const imagesService = () => {
  const self = {}

  self.logo = logo
  self.accueil = accueil

  return self
}
export default imagesService



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/images/images.service.js